import React from 'react'
import { Link } from 'react-router-dom'
import bgImage from "../../src/assets/images/maxresdefault.jpg"
// import Animation from "../../src/assets/animation/Animation.json"
// import Lottie from "lottie-react"
import EmailImage from "../../src/assets/images/email.png"


const SignUpEmailVerification = () => {
  return (
<div className="flex flex-wrap w-full h-screen">
        <div className="flex flex-col justify-center h-full w-full md:w-1/2">
            {/* <div className="flex justify-center pt-12 md:justify-start md:pl-12 md:-mb-24">
                <p className="p-4 text-xl font-bold text-white bg-black">
                    
                </p> 
            </div> */}
            <div className="flex flex-col justify-center px-8 pt-8 my-auto md:justify-start md:pt-12 md:px-24 lg:px-32">
                <p className="text-3xl text-center">
                    Check Your Mail.
                </p>
                <p className='text-center text-custom-brown'>Account verification link has been sent to the email address provided</p>
                <div className="w-[100px] h-[100px] p-0 mt-6 mx-auto box-border flex flex-col items-center justify-center rounded-md bg-[#f7f0fb]">
                    {/* <Lottie animationData={Animation} className='border w-full my-auto'  /> */}
                    <img src={EmailImage}  alt=''/>
                </div>
                <div className="pt-6 pb-12 text-center">
                    <p className='mb-1'>
                        Didn't get the mail? &nbsp;
                        <Link to="/verify-account" className="font-semibold underline hover:text-custom-dark-blue">
                            Send it again.
                        </Link>
                    </p>
                    <p>
                        Already Verified your email? &nbsp;
                        <Link to="/login" className="font-semibold underline hover:text-custom-dark-blue">
                            Login here.
                        </Link>
                    </p>
                </div>
            </div>
        </div>
        <div className="w-1/2 shadow-2xl">
            <img className="hidden object-cover object-right w-full h-screen md:block" alt='' src={bgImage}/>
        </div>
    </div>  )
}

export default SignUpEmailVerification